export enum PersonalTaskTemplateAction {
  SELECT,
  SELECT_TASK,
}

export interface IPersonalTaskTemplateAction {
  payload: any;
  type: PersonalTaskTemplateAction;
}
